import { Rest } from './rest'

const headers = ({ token }) => {
  return { Authorization: `Bearer ${token}` }
}
const Financial = new Rest(process.env.REACT_APP_FINANCIAL, headers)

export default Financial
